import { Box } from '@mui/material';
import { PickerSelectionState } from '@mui/x-date-pickers/internals';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import { Dayjs } from 'dayjs';
import React from 'react';
import useWeeklyStyles from './WeeklyDateSelectorStyles';

export interface CalendarDayOfWeekProps {
  date: Dayjs;
  dayIsBetween: boolean;
  isFirstDay: boolean;
  isLastDay: boolean;
  outsideCurrentMonth: boolean;
  // eslint-disable-next-line no-unused-vars
  onChange: (d: Dayjs) => void;
}

const CalendarDayOfWeek = (props: CalendarDayOfWeekProps) => {
  const {
    date,
    dayIsBetween,
    isFirstDay,
    isLastDay,
    outsideCurrentMonth,
    onChange,
  } = props;

  const _handleDaySelect = (d: Dayjs, isFinished: PickerSelectionState) => {
    onChange(d);
    return isFinished;
  };

  return (
    <Box
      sx={[
        { ...(dayIsBetween && useWeeklyStyles?.highlight) },
        { ...(isFirstDay && useWeeklyStyles.firstHighlight) },
        { ...(isLastDay && useWeeklyStyles.endHighlight) },
        {
          ...(dayIsBetween
            && !isFirstDay
            && !isLastDay
            && useWeeklyStyles.betweenHighlight),
        },
      ]}
      key={date.toString()}
    >
      <PickersDay
        day={date}
        outsideCurrentMonth={false}
        sx={[
          useWeeklyStyles.day,
          { ...(outsideCurrentMonth && useWeeklyStyles.nonCurrentMonthDay) },
          {
            ...(outsideCurrentMonth
              && dayIsBetween
              && useWeeklyStyles.highlightNonCurrentMonthDay),
          },
        ]}
        onDaySelect={(day: Dayjs, isFinish: PickerSelectionState) => _handleDaySelect(day, isFinish)}
      >
        <Box component="span" data-testid="date format">
          {' '}
          {date.format('DD')}{' '}
        </Box>
      </PickersDay>
    </Box>
  );
};

export default CalendarDayOfWeek;
